<!--
 * @Author: heroDHB
 * @Date: 2020-07-29 19:55:48
-->
<template>
  <div
    v-if="showFooterBar"
    class="button-bar"
    :style="{ paddingBottom: paddingBottom + 'px' }"
  >
    <div class="bar-container" :class="{ 'btn-style': !showBuyBtn }">
      <img
        v-if="showBuyBtn"
        class="button"        
        @click="navigateToBuyPage"
        src="../../assets/imgs/home/button-buy.png"
      />
      <img class="button" @click="handleOpen" src="../../assets/imgs/home/button-tutorial.png" />
      <img
        class="button"
        src="../../assets/imgs/home/button-share.png"
        @click="shareToFriend"
        id="copyBtn"
        :data-clipboard-text="copyText"
      />  
    </div>

    <div><a class="beianlink" href="https://beian.miit.gov.cn/">浙ICP备14005433号-2</a></div>
      
    <v-overlay :value="overlay">
      <div class="wxRightShareBox" @click="overlay = false">
        <div class="pointerImgBox">
          <img class="pointerImg" src="../../assets/imgs/share_pointer.png" />
          <div class="tip">
            请点击右上角
            <br />将它发送给指定朋友
            <br />或分享到朋友圈
          </div>
        </div>
      </div>
    </v-overlay>
    <v-snackbar v-model="snacker" centered timeout="4000">步骤已经复制，请打开微信，在任意对话框“粘贴”即可</v-snackbar>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      eager
      scrollable
    >
      <v-card tile>
        <v-toolbar style="flex-grow: 0" dark color="#032251">
          <v-btn icon @click="handleClose">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title>安装教程</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="d-flex align-center" style="padding: 0">
          <video
            ref="videoEle"
            poster="https://cdnv.vincicar.net/video/installstep20191201.thumb.jpg"
            controls="controls"
            width="100%"
            src="https://cdnv.vincicar.net/video/installstep20191227.mp4"
          ></video>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import ClipboardJS from 'clipboard';
import safeAreaInsets from 'safe-area-insets';
import qs from 'query-string';

export default {
  name: 'ButtonBar',
  data() {
    return {
      copyText: `思域、冠道、皓影、CRV、URV、CDX车机快捷优化系统教程：${window.location.protocol}//${window.location.host}`,
      isWeixin:
        navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
      overlay: false,
      snacker: false,
      paddingBottom: 0,
      dialog: false,
      showBuyBtn: false,
      showFooterBar: false,
    };
  },
  methods: {
    async initJssdk() {
      try {
        const res = await axios.get(
          `/vb/user/jsapi_param?url=${encodeURI(window.location.href)}`,
        );
        const resData = res.data;
        if (resData.code < 20000) {
          throw new Error(resData.message);
        }
        this.jssdkParam = resData.data;
        // eslint-disable-next-line
        const { appId, nonceStr, signature, timestamp } = this.jssdkParam;
        wx.config({
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'ononMenuShareQZone',
          ], // 必填，需要使用的JS接口列表
        });
        const shareTitle =
          '本田原厂中控屏升级优化安装软件|思域、冠道、皓影、CRV、URV、讴歌CDX专用';
        // eslint-disable-next-line
        const shareDesc =
          '【本田车友必看】不加装、改动硬件，原厂中控屏无损升级优化安装软件，几分钟即可搞定';
        const shareLink = 'https://info.vincicar.com/';
        const shareImgUrl = 'https://info.vincicar.com/shareassistant.jpg';

        wx.ready(() => {
          const shareConfig = {
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImgUrl,
          };
          wx.updateAppMessageShareData(shareConfig);
          wx.updateTimelineShareData(shareConfig);
          wx.onMenuShareWeibo(shareConfig);
          wx.onMenuShareQZone(shareConfig);
          wx.onMenuShareTimeline(shareConfig);
          wx.onMenuShareAppMessage(shareConfig);
          wx.onMenuShareQQ(shareConfig);
          wx.onMenuShareQZone(shareConfig);
        });
      } catch (e) {
        // nothing
      }
    },
    shareToFriend() {
      if (!this.isWeixin) {
        this.snacker = true;
        return;
      }
      this.overlay = true;
    },
    navigateToBuyPage() {
      window.location.href = 'https://buyx.vincicar.com';
    },
    handleClose() {
      this.dialog = false;
      this.$refs.videoEle.pause();
    },
    handleOpen() {
      this.dialog = true;
      this.$refs.videoEle.play();
    },
    handleBodyScroll() {
      try {
        if (window.scrollY > window.screen.height / 2) {
          this.showFooterBar = true;
        } else {
          this.showFooterBar = false;
        }
      } catch (e) {
        // nothing
      }
    },
  },
  mounted() {
    // eslint-disable-next-line no-new
    new ClipboardJS('#copyBtn');
    this.initJssdk();
    this.paddingBottom = safeAreaInsets.bottom;

    const { mphone } = qs.parse(window.location.search);
    if (mphone) {
      this.showBuyBtn = true;
    }

    window.addEventListener('scroll', this.handleBodyScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleBodyScroll);
  },
};
</script>
<style>
.v-overlay__content {
  width: 100%;
  height: 100%;
}
</style>
<style lang="less" scoped>
.button-bar {    
  position: fixed;
  bottom: 0;
  z-index: 100;
  width: 750px;  
  background: rgba(3, 34, 81, 0.9);
  padding: 20px 15px;  

  .wxRightShareBox {
    position: relative;
    height: 100%;
    width: 100%;
    .pointerImgBox {
      position: relative;
      display: inline-block;
      width: 750px;
      text-align: right;
      overflow: visible;
      img {
        display: inline-block !important;
        margin: 20px;
        width: 375px;
        height: 350px;
      }
      .tip {
        line-height: 1.7;
        text-align: center;
        white-space: nowrap;
        font-size: 40px;
        color: #fff;
        position: absolute;
        width: 100%;
        bottom: 0;
        transform: translateY(102%);
      }
    }
  }
  .bar-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    &.btn-style {
      justify-content: space-around;
    }
    .button {
      width: 207px;
      height: 79px;
    }
  }
  .beianlink {
    color: #bbb;
    font-size: 12px;
  }
}
</style>
